import { Link, useLocation } from 'react-router-dom'
import { CATEGORIES } from '@/registry'
import { toCurrentLocalePath } from '@/i18n/routing'

export function Footer() {
  const { pathname } = useLocation()
  const localize = (path: string) => toCurrentLocalePath(pathname, path)

  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-white mb-3 text-lg">⚙ Toolvance</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Fast, accurate calculators, converters and useful tools for everyday life, work, study and engineering.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Categories</h4>
            <ul className="space-y-1.5 text-sm">
              {CATEGORIES.slice(0, 5).map(cat => (
                <li key={cat.id}>
                  <Link to={localize(`/${cat.id}`)} className="hover:text-white transition-colors">
                    {cat.icon} {cat.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Popular Calculators</h4>
            <ul className="space-y-1.5 text-sm">
              <li><Link to={localize('/calculators/ohms-law')} className="hover:text-white transition-colors">Ohm's Law</Link></li>
              <li><Link to={localize('/calculators/battery-runtime')} className="hover:text-white transition-colors">Battery Runtime</Link></li>
              <li><Link to={localize('/calculators/electricity-cost')} className="hover:text-white transition-colors">Electricity Cost</Link></li>
              <li><Link to={localize('/calculators/bmi')} className="hover:text-white transition-colors">BMI Calculator</Link></li>
              <li><Link to={localize('/calculators/percentage')} className="hover:text-white transition-colors">Percentage</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-3">Legal</h4>
            <ul className="space-y-1.5 text-sm">
              <li><Link to={localize('/privacy')} className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to={localize('/terms')} className="hover:text-white transition-colors">Terms of Use</Link></li>
              <li><Link to={localize('/contact')} className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 text-sm text-gray-500 flex flex-col sm:flex-row justify-between gap-2">
          <p>© {new Date().getFullYear()} Toolvance — Free Engineering Calculators</p>
          <p>All calculations are for informational purposes only.</p>
        </div>
      </div>
    </footer>
  )
}
